import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { decryptString } from 'src/app/lib/cryptoJs';

@Component({
  selector: 'app-deeplink',
  templateUrl: './deeplink.component.html',
  styleUrls: ['./deeplink.component.css']
})
export class DeeplinkComponent implements OnInit {
  requestId: string = ""
  constructor(private route: ActivatedRoute) {}
  // ngOnInit() {
  //    const Id = this.route.snapshot.params['requestId'];
  //    this.requestId = decryptString(Id, true);
  //   this.route.queryParams.subscribe((params) => {
  //     let redirectUrl = params['redirect'];

  //     if (redirectUrl) {
  //      // redirectUrl = decodeURIComponent(redirectUrl);
  //       // const urlParams = new URL(redirectUrl);
  //       // const requestId = urlParams.searchParams.get('requestId');
  //       setTimeout(() => {
  //         window.location.href = redirectUrl;
  //       }, 500);
  //     }
  //   });
  // }
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      const redirectUrl = params['redirect'];
      if (redirectUrl) {
        setTimeout(() => {
          window.location.href = redirectUrl;
          // setTimeout(() => {
          //   window.location.href = 'https://play.google.com/store/apps/details?id=com.credbull.app';
          // }, 2000); // Redirect to Play Store if app is not installed
        }, 500);
      }
    });
  }

}
